import React, { useState } from 'react'
import UccSearchContent from './UccSearchContent'
import { performUccSearch, performUccSearchDemoMode, dispatchUccSearchParameters, dispatchUpdatedUccResponse } from 'actions/applicants'
import { buildUccSearchPayload } from "constants/utilityFunctions"
import UccSearchForm from './UccSearchForm'
import { useDispatch, useSelector } from 'react-redux'
import {useAppContext} from "../../../../../../../../context/AppContext";

const UccSearchTab = ({ selectedEntity, applicationId, debtorApplication, creditUsageEnabled, creditCosts }) => {

    const uccResponseFromStore = useSelector(state => state.applicant.ucc.response)
    const [uccResponse, setUccResponse] = useState(uccResponseFromStore)
    const [loading, setLoading] = useState(false)
    const { type: entityType, uuid: entityId } = selectedEntity
    const {isDemoMode} = useAppContext()

    const dispatch = useDispatch()
    // submit form
    const handleUccSearch = (data) => {
        setLoading(true)
        const payload = buildUccSearchPayload({ data, entityType, entityId })

        if (isDemoMode){
            performUccSearchDemoMode(applicationId, payload)()
                .then(response => {
                    setUccResponse(response)
                    dispatchUccSearchParameters(data, dispatch)
                    dispatchUpdatedUccResponse(response, dispatch)
                })
                .finally(() => { setLoading(false) })
        } else {
            performUccSearch(applicationId, payload)()
                .then(response => {
                    setUccResponse(response)
                    dispatchUccSearchParameters(data, dispatch)
                    dispatchUpdatedUccResponse(response, dispatch)
                })
                .finally(() => { setLoading(false) })
        }
    }

    return (
        <div className='mt-3'>
            <UccSearchForm selectedEntity={selectedEntity} onSubmit={handleUccSearch} loading={loading}
                           creditUsageEnabled={creditUsageEnabled} creditCosts={creditCosts} />
            <UccSearchContent uccResponse={uccResponse} applicationId={applicationId} debtorApplication={debtorApplication} />
        </div>
    )
}

export default UccSearchTab